module.exports = __webpack_public_path__ + "img/splash1.995daa2a.png";